import {
  Box,
  CardMedia,
} from '@mui/material';
import TextLines from '../../../text/TextLines';

import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  card: {},
  cardId: '',
};

const CauseAndEffectActivityCard = (p) => {
  const {
    card,
    cardId,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <Box
      id={cardId}
      key={cardId}
      boxShadow={2}
      className='cause-and-effect-card'
    >
      {card.image ? <CardMedia image={card.image} className='cause-and-effect-card-image' /> : ''}
      {card.text ? (
        <div className={`cause-and-effect-card-text ${card.image ? 'text-with-image' : ''}`}>
          <TextLines
            textLines={card.text}
            componentKey={`text-line-${cardId}`}
          />
        </div>
      ) : ''}
    </Box>
  );
};

export default CauseAndEffectActivityCard;
